export const ALL_ORDERS = 'ALL_ORDERS' as const;
export const ORDERS_PAID_BY_CASH = 'ORDERS_PAID_BY_CASH' as const;
export const ORDERS_PAID_THROUGH_DELIVEROO =
  'ORDERS_PAID_THROUGH_DELIVEROO' as const;
